import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-fluid admin-page" }
const _hoisted_2 = { class: "search-area" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group search-btn ta-center" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "text-warning movie-group-warn-text ml10 mt8"
}
const _hoisted_8 = {
  key: 0,
  class: "collection-destroy"
}
const _hoisted_9 = { class: "main-area" }
const _hoisted_10 = {
  key: 0,
  class: "table admin-table"
}
const _hoisted_11 = { class: "table-secondary header-row" }
const _hoisted_12 = { class: "checkbox" }
const _hoisted_13 = { class: "vm head-edit" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "vm ws-nowrap" }
const _hoisted_16 = { class: "vm ws-nowrap" }
const _hoisted_17 = { class: "vm ws-nowrap" }
const _hoisted_18 = { class: "vm ws-nowrap" }
const _hoisted_19 = { class: "vm" }
const _hoisted_20 = { class: "vm ws-nowrap" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "p1" }
const _hoisted_25 = { class: "p1" }
const _hoisted_26 = { class: "p1" }
const _hoisted_27 = { class: "p1" }

import movieGroupApi from 'src/apis/movieGroup';
import {
  computed,
  onMounted,
  reactive,
} from 'vue';
import { useFullScreenSpinner } from 'src/composables/useFullScreenSpinner';
import type { AdminMovieGroup, AdminMovieTag } from 'src/models/movieGroup';
import {
  getAggregatedMovieTagsFromMovieLists,
  getAggregatedMovieTagsFromMovieList,
  type MovieTagMap,
  type ResultTag,
} from 'src/lib/tagModalHelper';
import type { PageItem } from 'src/models';
import { dtFormat } from 'src/lib/dateHelper';
import { paginateItems } from 'src/lib/utils';

interface SearchParams {
  dtFrom: Date;
  dtTo: Date;
  device_id_or_car_name: string | null;
}
type FilteredMovieGroup = AdminMovieGroup & {
  checked: boolean;
};
interface MovieTagModal {
  show: boolean;
  movieGroups: AdminMovieGroup[];
  tags: MovieTagMap[];
}
type AdminMovieGroupEdit = Omit<AdminMovieGroup, 'id'> & {
  id: number | null;
};

interface Pagination {
  currentPage: number;
  itemsPerPage: number;
}

interface MovieGroupSearchState {
  search: SearchParams;
  filteredMovieGroups: FilteredMovieGroup[];
  hasMaxSearchResults: boolean;
  showSearchErrorModal: boolean;
  pager: Pagination;
}

interface MovieGroupDestroyState {
  showDestroyModal: boolean;
  showCollectionDestroyModal: boolean;
  showErrorModal: boolean;
  editting: Partial<AdminMovieGroupEdit>;
  allSelected: boolean;
}

const maxSearchResultLimit = 1000;
const destroyModalTitle = '削除';
const destroyModalMsg = 'を削除してもよろしいですか？';
const collectionDestroyModalTitle = '一括削除';
const errorModalTitle = 'エラー';
const errorModalMsg = '不明なエラーです。ネットワークの状態をご確認いただき再度お試し下さい。';
const searchErrorModalMsg = '検索期間は31日以内に設定して下さい';

export default /*@__PURE__*/_defineComponent({
  __name: 'MovieGroups',
  setup(__props) {

const now = new Date();
const initSearchState = (): SearchParams => {
  return {
    // 1週間前から今日
    dtFrom: new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7),
    dtTo: new Date(now.getFullYear(), now.getMonth(), now.getDate()),
    device_id_or_car_name: null,
  };
};
const initEdittingState = (): Partial<AdminMovieGroupEdit> => {
  return {
    id: null,
  };
};
const initEditMovieTagModalState = (): MovieTagModal => {
  return {
    show: false,
    movieGroups: [],
    tags: [],
  };
};
const initPagerState = (): Pagination => {
  return {
    currentPage: 1,
    itemsPerPage: 50,
  };
};
const searchState = reactive<MovieGroupSearchState>({
  search: initSearchState(),
  filteredMovieGroups: [],
  hasMaxSearchResults: false,
  showSearchErrorModal: false,
  pager: initPagerState(),
});
const destroyState = reactive<MovieGroupDestroyState>({
  showDestroyModal: false,
  showCollectionDestroyModal: false,
  showErrorModal: false,
  editting: initEdittingState(),
  allSelected: false,
});
const tagEditState = reactive<MovieTagModal>(initEditMovieTagModalState());

const selectedNum = computed<number>(() => {
  return searchState.filteredMovieGroups.filter((g) => g.checked).length;
});
const paginatedMovieGroups = computed<FilteredMovieGroup[]>(() => {
  return paginateItems(searchState.filteredMovieGroups, searchState.pager);
});
// テンプレートからstateのプロパティに直接アクセスできるよう展開する
const collectionDestroyModalMsg = computed<string>(() => {
  return selectedNum.value.toString() + '件を一括削除してもよろしいですか？';
});
const isValidSearchParams = computed<boolean>(() => {
  const params = searchState.search;
  return params.dtFrom instanceof Date && params.dtTo instanceof Date;
});
const longerThanPeriodLimit = computed<boolean>(() => {
  return searchState.search.dtTo.getTime() - searchState.search.dtFrom.getTime() > 31 * 24 * 60 * 60 * 1000;
});
const doSearch = () => {
  if (!isValidSearchParams.value) return;

  if (longerThanPeriodLimit.value) {
    searchState.showSearchErrorModal = true;
    return;
  }
  resetSearchResults();

  const params = searchState.search;
  const reqParams = {
    from_ts: params.dtFrom,
    to_ts: new Date(params.dtTo.valueOf() + 86400 * 1000),
  };

  movieGroupApi.adminIndex(reqParams)
    .then((movieGroupsOrig) => {
      if (!movieGroupsOrig || movieGroupsOrig.length === 0) return;

      if (movieGroupsOrig.length === maxSearchResultLimit) {
        searchState.hasMaxSearchResults = true;
      }
      filterSearch(movieGroupsOrig);
    });
};

onMounted(doSearch);

const filterSearch = (movieGroupsOrig: AdminMovieGroup[]) => {
  searchState.filteredMovieGroups = movieGroupsOrig.filter(movieGroup => {
      if (searchState.search.device_id_or_car_name != null &&
        searchState.search.device_id_or_car_name !== '' &&
        movieGroup.deviceId.toString().indexOf(searchState.search.device_id_or_car_name) < 0 &&
        movieGroup.carName.indexOf(searchState.search.device_id_or_car_name) < 0) {
        return false;
      }
      return true;
    })
    .map(movieGroup => ({ ...movieGroup, checked: false }));
  destroyState.allSelected = false;
};
const resetSearchResults = () => {
  searchState.filteredMovieGroups = [];
  searchState.pager.currentPage = 1;
  searchState.hasMaxSearchResults = false;
};
const onPageClick = (pageItem: PageItem) => {
  searchState.pager.currentPage = pageItem.pageNum;
};
const allSelect = () => {
  for (let i = 0; i < searchState.filteredMovieGroups.length; i++) {
    searchState.filteredMovieGroups[i].checked = true;
  }
};
const allDeselect = () => {
  for (let i = 0; i < searchState.filteredMovieGroups.length; i++) {
    searchState.filteredMovieGroups[i].checked = false;
  }
};
const allSelectBtn = () => {
  if (destroyState.allSelected) {
    allSelect();
  } else {
    allDeselect();
  }
};
const collectionDestroy = () => {
  destroyState.showCollectionDestroyModal = true;
};
const collectionDestroySave = () => {
  const ids = searchState.filteredMovieGroups.filter((g) => {
    return g.checked;
  }).map((g) => {
    return g.id;
  });
  movieGroupApi.adminCollectionDestroy({
    ids: ids,
  }).then(() => {
    destroyState.showCollectionDestroyModal = false;
    doSearch();
  }).catch(() => {
    destroyState.showCollectionDestroyModal = false;
    destroyState.showErrorModal = true;
  });
};
const tryDestroy = (obj: AdminMovieGroup) => {
  destroyState.editting = obj;
  destroyState.showDestroyModal = true;
};
const doDestroy = () => {
  if (destroyState.editting.id == null) return;

  movieGroupApi.adminDestroy(
    destroyState.editting.id,
  ).then(() => {
    destroyState.showDestroyModal = false;
    doSearch();
  }).catch(() => {
    destroyState.showDestroyModal = false;
    destroyState.showErrorModal = true;
  });
};
const movieTagsOfMovieGroup = (mg: AdminMovieGroup): AdminMovieTag[] => {
  const movieTagMap = mg.movies.reduce((acc: { [key:number] : AdminMovieTag }, movie) => {
    movie.tags.forEach(tag => { acc[tag.id] = tag; }); return acc;
  }, {});
  return Object.values(movieTagMap);
};
const bulkEditMovieTag = async() => {
  const mgs = searchState.filteredMovieGroups.filter(g => g.checked);
  tagEditState.movieGroups = mgs;
  tagEditState.tags =
    getAggregatedMovieTagsFromMovieLists(mgs);
  tagEditState.show = true;
};
const editMovieTag = async(obj: AdminMovieGroup) => {
  tagEditState.movieGroups = [obj];
  tagEditState.tags =
    getAggregatedMovieTagsFromMovieList(obj);
  tagEditState.show = true;
};
const fullScreenSpinner = useFullScreenSpinner();
const updateMovieTags = async(resultTags: ResultTag[]) => {
  fullScreenSpinner.notifyShow({ message: '保存しています...', isHtmlMessage: false });
  const movieGroups = tagEditState.movieGroups;
  const promises = movieGroups.map((mg, idx) => {
    const movieInfos = mg.movies.map(m => {
      const tagIds = resultTags.filter(resTag => {
        return !resTag.isPartiallySelected || m.tags.find(e => e.id === resTag.id);
      }).map(e => e.id);
      return { movie_id: m.id, tag_ids: tagIds };
    });
    return movieGroupApi.adminUpdateMovieTags(mg.id, { movie_infos: movieInfos })
      .then((updatedMovieGroup) => {
        movieGroups[idx].movies = updatedMovieGroup.movies;
      });
  });
  try {
    await Promise.all(promises);
  } finally {
    // 保存失敗時もスピナーを出しっぱなしにしない
    fullScreenSpinner.notifyHide();
  }
  tagEditState.show = false;
};


return (_ctx: any,_cache: any) => {
  const _component_MyCalendar = _resolveComponent("MyCalendar")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_TagModal = _resolveComponent("TagModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "title-area" }, [
      _createElementVNode("h2", null, "動画管理")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "search-form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-control-label" }, "期間", -1)),
          _createElementVNode("div", null, [
            _createVNode(_component_MyCalendar, {
              class: "date-from",
              "date-value": searchState.search.dtFrom,
              onDateInput: _cache[0] || (_cache[0] = ($event: any) => (searchState.search.dtFrom = $event))
            }, null, 8, ["date-value"]),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "ib waveline ta-center ml4 mr4" }, "〜", -1)),
            _createVNode(_component_MyCalendar, {
              class: "date-to",
              "date-value": searchState.search.dtTo,
              onDateInput: _cache[1] || (_cache[1] = ($event: any) => (searchState.search.dtTo = $event))
            }, null, 8, ["date-value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-control-label device-id-or-car-name" }, "車載器ID・車両番号", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchState.search.device_id_or_car_name) = $event))
          }, null, 512), [
            [_vModelText, searchState.search.device_id_or_car_name]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            onClick: doSearch,
            disabled: !isValidSearchParams.value
          }, " 検索 ", 8, _hoisted_6)
        ])
      ], 32),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-warning movie-group-warn-text ml10 mt8" }, " ※エンジンONからOFFまでを一連の動画とし、一行にまとめて表示しています。個別に編集をする場合は地図画面から行ってください。 ", -1)),
      (searchState.hasMaxSearchResults)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " ※件数が" + _toDisplayString(maxSearchResultLimit) + "件を超えているので最初の" + _toDisplayString(maxSearchResultLimit) + "件を表示しています "))
        : _createCommentVNode("", true)
    ]),
    (selectedNum.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createTextVNode(" 検索結果" + _toDisplayString(selectedNum.value) + "件が選択されています。 ", 1),
          _createElementVNode("button", {
            class: "btn btn-info btn-sm",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (bulkEditMovieTag()))
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("i", { class: "fas fa-tag mr4" }, null, -1),
            _createTextVNode("一括タグ編集 ", -1)
          ]))]),
          _createElementVNode("button", {
            class: "btn btn-danger btn-sm ml12",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (collectionDestroy()))
          }, [...(_cache[18] || (_cache[18] = [
            _createElementVNode("i", { class: "fas fa-trash-alt mr4" }, null, -1),
            _createTextVNode("一括削除 ", -1)
          ]))])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Pagination, {
        "current-page": searchState.pager.currentPage,
        "total-items": searchState.filteredMovieGroups.length,
        "items-per-page": searchState.pager.itemsPerPage,
        onPageClick: onPageClick
      }, null, 8, ["current-page", "total-items", "items-per-page"]),
      (searchState.filteredMovieGroups.length > 0)
        ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_11, [
                _createElementVNode("th", _hoisted_12, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((destroyState.allSelected) = $event)),
                    onChange: allSelectBtn
                  }, null, 544), [
                    [_vModelCheckbox, destroyState.allSelected]
                  ])
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("th", null, "開始時刻", -1)),
                _cache[20] || (_cache[20] = _createElementVNode("th", null, "終了時刻", -1)),
                _cache[21] || (_cache[21] = _createElementVNode("th", null, "車載器ID", -1)),
                _cache[22] || (_cache[22] = _createElementVNode("th", null, "車両番号", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("th", null, "動画タグ", -1)),
                _cache[24] || (_cache[24] = _createElementVNode("th", null, null, -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedMovieGroups.value, (e) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: e.id,
                  class: _normalizeClass(["data-row", { checked: e.checked }])
                }, [
                  _createElementVNode("td", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => ((e.checked) = $event)
                    }, null, 8, _hoisted_14), [
                      [_vModelCheckbox, e.checked]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(dtFormat)(e.startTs)), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(dtFormat)(e.endTs)), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(e.deviceId), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(e.carName), 1),
                  _createElementVNode("td", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(movieTagsOfMovieGroup(e), (tag, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: i,
                        class: _normalizeClass(["tag-badge mr4 mb4 ws-nowrap", 'tag-badge-' + tag.tagType1])
                      }, _toDisplayString(tag.tagName), 3))
                    }), 128))
                  ]),
                  _createElementVNode("td", _hoisted_20, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-info",
                      onClick: ($event: any) => (editMovieTag(e))
                    }, [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("i", { class: "fas fa-tag" }, null, -1),
                      _createTextVNode(" タグ編集 ", -1)
                    ]))], 8, _hoisted_21),
                    _createElementVNode("button", {
                      class: "delete-btn btn btn-danger btn-sm",
                      onClick: ($event: any) => (tryDestroy(e))
                    }, [...(_cache[26] || (_cache[26] = [
                      _createElementVNode("i", { class: "fas fa-trash-alt mr4" }, null, -1),
                      _createTextVNode("削除 ", -1)
                    ]))], 8, _hoisted_22)
                  ])
                ], 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Pagination, {
        "current-page": searchState.pager.currentPage,
        "total-items": searchState.filteredMovieGroups.length,
        "items-per-page": searchState.pager.itemsPerPage,
        onPageClick: onPageClick
      }, null, 8, ["current-page", "total-items", "items-per-page"])
    ]),
    (destroyState.showCollectionDestroyModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          title: collectionDestroyModalTitle,
          "show-bottom-dismiss-button": true,
          onClose: collectionDestroySave,
          onDismiss: _cache[7] || (_cache[7] = ($event: any) => (destroyState.showCollectionDestroyModal = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", {
                class: "p2 font-mtx-desc",
                innerHTML: collectionDestroyModalMsg.value
              }, null, 8, _hoisted_23)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (destroyState.showDestroyModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          title: destroyModalTitle,
          "show-bottom-dismiss-button": true,
          onClose: doDestroy,
          onDismiss: _cache[8] || (_cache[8] = ($event: any) => (destroyState.showDestroyModal = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_24, [
                _cache[27] || (_cache[27] = _createTextVNode("開始時刻", -1)),
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "colon" }, null, -1)),
                _createTextVNode(_toDisplayString(_unref(dtFormat)(destroyState.editting.startTs)), 1)
              ]),
              _createElementVNode("p", _hoisted_25, [
                _cache[29] || (_cache[29] = _createTextVNode("終了時刻", -1)),
                _cache[30] || (_cache[30] = _createElementVNode("span", { class: "colon" }, null, -1)),
                _createTextVNode(_toDisplayString(_unref(dtFormat)(destroyState.editting.endTs)), 1)
              ]),
              _createElementVNode("p", _hoisted_26, [
                _cache[31] || (_cache[31] = _createTextVNode("車載器ID", -1)),
                _cache[32] || (_cache[32] = _createElementVNode("span", { class: "colon" }, null, -1)),
                _createTextVNode(_toDisplayString(destroyState.editting.deviceId), 1)
              ]),
              _createElementVNode("p", _hoisted_27, [
                _cache[33] || (_cache[33] = _createTextVNode("車両番号", -1)),
                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "colon" }, null, -1)),
                _createTextVNode(_toDisplayString(destroyState.editting.carName), 1)
              ]),
              _createElementVNode("p", {
                class: "p2 font-mtx-desc",
                innerHTML: destroyModalMsg
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (searchState.showSearchErrorModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 3,
          title: "検索エラー",
          "show-bottom-dismiss-button": false,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (searchState.showSearchErrorModal = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", {
                class: "p2 font-mtx-desc",
                innerHTML: searchErrorModalMsg
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (destroyState.showErrorModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 4,
          title: errorModalTitle,
          "show-bottom-dismiss-button": false,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (destroyState.showErrorModal = false))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", {
                class: "p2 font-mtx-desc",
                innerHTML: errorModalMsg
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (tagEditState.show)
      ? (_openBlock(), _createBlock(_component_TagModal, {
          key: 5,
          title: "動画タグの編集",
          modelValue: tagEditState.tags,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((tagEditState.tags) = $event)),
          onClose: updateMovieTags,
          onDismiss: _cache[12] || (_cache[12] = ($event: any) => (tagEditState.show = false))
        }, null, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}
}

})